import { render, staticRenderFns } from "./UserProfileConsents.vue?vue&type=template&id=e552db32&"
import script from "./UserProfileConsents.vue?vue&type=script&lang=js&"
export * from "./UserProfileConsents.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileConsents.vue?vue&type=style&index=0&id=e552db32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports